import { type } from 'type-r'

export function parsePhone(val) {
    if (typeof val == 'string') {
        return val;
    }
    else if(val) 
        return val.toString()
}
var Phone = type(String).parse(parsePhone);
export default Phone;
